import React from 'react';
import Dashboard from '../Dashboard';
import PassportInfoMain from './PassportInfoMain'

export default function PassportInfo() {
    return (
        <div>
            <Dashboard cmp={<PassportInfoMain />} />
        </div>
    )
}

